export enum TabList {
  "web",
  "wechat",
  "douyin",
  "redbook",
  "kuaishou",
  "weibo",
}

export const tabMap = {
  [TabList.web]: "web",
  [TabList.wechat]: "wechat",
  [TabList.douyin]: "douyin",
  [TabList.redbook]: "redbook",
  [TabList.kuaishou]: "kuaishou",
  [TabList.weibo]: "weibo",
}

export function getPlatformByTabList(tabList: TabList) {
  return ["web", "wechat", "douyin", "redbook", "kuaishou", "weibo"][tabList];
}
